import { AwesomeButton } from "react-awesome-button";
import { Fade } from "react-awesome-reveal";
import {
  BsTelegram,
  BsGithub,
  BsTwitter,
  BsDiscord
} from "react-icons/bs";
import { socialLinks } from "../data/socialLinks";

export default function Contact() {
  return (
    <div className="flex flex-col h-full px-3 overflow-x-hidden overflow-y-auto dark:bg-[#2a2a2a] bg-white transition-all duration-300">
      <div className="flex flex-col items-center justify-center w-full md:min-h-[100vh] gap-10 my-[100px] lg:my-auto">
        <div className="max-w-[650px] items-center justify-center flex flex-col gap-10 text-left relative">
          <Fade delay={1000} triggerOnce={true}>
            <h1 className="dark:text-[#cacaca] uppercase md:text-[2.625em] text-[2em] font-extrabold text-[#434343]">
              Get in touch
            </h1>
          </Fade>
          <Fade
            delay={1300}
            triggerOnce={true}
            className="flex items-center justify-center w-full text-center"
          >
            <small className="dark:text-[#9a9a9a] text-[#6e6e6e]">
              {`If you want to get in touch and discuss more about your project, please send an email to`}
              &nbsp;
              <a
                href="mailto:davidkano.dk@gmail.com"
                className="text-xl dark:text-[#bbbbbb] transition-all duration-300 dark:hover:text-white text-[#787878] hover:text-[#020202]"
              >
                {" "}
                davidkano.dk@gmail.com
                {"  "}
              </a>
              &nbsp;and let's talk.
            </small>
          </Fade>
          <div className="w-full">
            <Fade delay={1500} triggerOnce={true}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2832.0342243266123!2d20.52581069067945!3d44.78010760423995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a70b04ff3e8ef%3A0xca5ea6113bb6a0c6!2sNikole%20Vuli%C4%87a%2010%2C%20Beograd%2C%20Serbia!5e0!3m2!1sen!2sde!4v1707550581156!5m2!1sen!2sde"
                style={{ border: 0, width: "100%", height: "100%" }}
                allowFullScreen={true}
                loading="lazy"
                className="min-h-[300px]"
              />
            </Fade>
          </div>
          <Fade delay={1700} triggerOnce={true}>
            <h1 className="dark:text-[#cacaca] uppercase text-[1.25em] font-extrabold text-[#434343]">
              Let's get socials
            </h1>
            <p className="dark:text-[#9a9a9a] text-center md:text-left text-sm text-[#747474]">
              Follow profiles on Socials.
            </p>
          </Fade>

          <Fade delay={1900} triggerOnce={true}>
            <div className="grid items-center justify-center grid-cols-2 gap-5 md:grid-cols-4">
              <AwesomeButton type="twitter" href={socialLinks.twitter}>
                <span className="flex items-center justify-center gap-1">
                  <BsTwitter size={20} />
                  <span className="text-sm font-light uppercase">Twitter</span>
                </span>
              </AwesomeButton>
              <AwesomeButton type="linkedin" href={socialLinks.discord}>
                <span className="flex items-center justify-center gap-1">
                  <BsDiscord size={20} />
                  <span className="text-sm font-light uppercase">Discord</span>
                </span>
              </AwesomeButton>

              <AwesomeButton type="github" href={socialLinks.github}>
                <span className="flex items-center justify-center gap-1">
                  <BsGithub size={20} />
                  <span className="text-sm font-light uppercase">github</span>
                </span>
              </AwesomeButton>
              <AwesomeButton type="primary" href={socialLinks.telegram}>
                <span className="flex items-center justify-center gap-1">
                  <BsTelegram size={20} />
                  <span className="text-sm font-light uppercase">Telegram</span>
                </span>
              </AwesomeButton>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
}
